import React, { useEffect, createElement } from 'react';
import { LandingPage } from './components/LandingPage';
export function App() {
  useEffect(() => {
    // Meta Pixel Code - Safe implementation
    ;
    (function (f: any, b: any, e: any, v: any, n: any, t: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = v;
      // Safely append to head instead of using insertBefore
      b.head.appendChild(t);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
    // Initialize Meta Pixel
    ;
    (window as any).fbq('init', '1633635844670891');
    (window as any).fbq('track', 'PageView');
    // Add noscript fallback image
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=1633635844670891&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }, []);
  return <LandingPage data-id="element-0" />;
}